import { makeEnvironmentProviders } from '@angular/core';
import { PackageRepository } from '../../@core/repositories/package.repository';
import { PromoRepository } from '../../@core/repositories/promo.repository';
import { OtpRepository } from '../../@core/repositories/otp.repository';
import { CheckoutRepository } from '@data/repositories/checkout.repository';
import { RoamingRepository } from '@data/repositories/roaming.repository';
import { WorldCupRepository } from '@data/repositories/world-cup.repository';
import { HeaderRepository } from '@data/repositories/header.repository';
import { PromoAdapter } from '../repository/promo/promo.adapter';
import { PackageAdapter } from '../repository/package/package.adapter';
import { CheckoutAdapter } from '../repository/checkout/checkout.adapter';
import { OtpAdapter } from '../repository/otp/otp.adapter';
import { RoamingAdapter } from '../repository/roaming/roaming.adapter';
import { WorlCupAdapter } from '../repository/world-cup/world-cup.adapter';
import { HeaderAdapter } from '../repository/header/header.adapter';
// import { PromoMock } from '../repository/promo/promo.mock';
// import { PackageMock } from '../repository/package/package.mock';
// import { CheckoutMock } from '../repository/checkout/checkout.mock';
// import { OtpMock } from '../repository/otp/otp.mock';
// import { RoamingMock } from '../repository/roaming/roaming.mock';
// import { WorlCupMock } from '../repository/world-cup/world-cup.mock';
// import { HeaderMock } from '../repository/header/header.mock';

export const repositoryProviders = () => {
    return makeEnvironmentProviders([
        // { provide: PromoRepository, useClass: PromoMock },
        // { provide: PackageRepository, useClass: PackageMock },
        // { provide: CheckoutRepository, useClass: CheckoutMock },
        // { provide: OtpRepository, useClass: OtpMock },
        // { provide: RoamingRepository, useClass: RoamingMock },
        // { provide: WorldCupRepository, useClass: WorlCupMock },
        // { provide: HeaderRepository, useClass: HeaderMock }
        { provide: PromoRepository, useClass: PromoAdapter },
        { provide: PackageRepository, useClass: PackageAdapter },
        { provide: CheckoutRepository, useClass: CheckoutAdapter },
        { provide: OtpRepository, useClass: OtpAdapter },
        { provide: RoamingRepository, useClass: RoamingAdapter },
        { provide: WorldCupRepository, useClass: WorlCupAdapter },
        { provide: HeaderRepository, useClass: HeaderAdapter }
    ]);
};
